import React from "react";

export const TooltipContext = React.createContext({
  colour: "#000",
});
